export interface ResetPasswordDto {
  temporaryPassword: string; // Required, max 100
  requirePasswordChange?: boolean; // Default true
  resetReason?: string | null; // Max 200
  sendNotification?: boolean; // Default true
}
